<template>
  <!--<transition name="slide-up">-->
    <!--todo make a component-->
    <div class="drawer-mobile__tabs-item">
      <div class="flex justify-between tabs-item__header">
        <h4 class="text-button font-bold">
          {{ title }}
        </h4>
        <button class="tab-item__button-dismiss mr-2" @click="dismiss">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
        </button>
      </div>

      <slot></slot>
      <!--<div class="tabs-item__content">-->

      <!--</div>-->
      <!--<div class="tabs-item__footer">-->

      <!--</div>-->

    </div>
  <!--</transition>-->
</template>

<script>
  export default {
    name: "MobileTab",
    props: {
      title: {
        type: String,
        default: 'Title',
      }
    },
    methods: {
      dismiss: function() {
        this.$emit('dismiss');
      }
    }

  }
</script>

<style scoped>
  .slide-up-enter-active, .slide-up-leave-active {
    opacity: 1;
    /*z-index: 15;*/
  }
  .slide-up-enter, .slide-up-leave-to {
    opacity: 0;
    transform: translateY(100%);
  }

  .slide-up-leave-to {
    z-index: 5;
  }

  .tab-item__button-dismiss {
    color: #7C7C7C;
  }
</style>